import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => {
  return {
    app: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100dvh',
    },
    content: {
      flexGrow: 1,
    },
  };
});
